import React from "react";
import AdminReviewTypeListingComponent from "../../Components/adminReviewTypeListingComponent";

const ReviewTypeListingPage = () => {
  return (
    <div className="main-wrapper">
      <div className="content-wrapper">
        <AdminReviewTypeListingComponent />
      </div>
    </div>
  );
};

export default ReviewTypeListingPage;
